import React from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import * as Styles from './MemberNavigator.style';
import { navLinks } from 'utils/nav-links-util';
import Dashboard from './dashboard/Dashboard';
import AppDrawerContainer from 'layout/app-drawer/AppDrawer.container';
import NotFound from 'layout/not-found/NotFound';
import HeaderContainer from 'layout/header/Header.container';
import queryString from 'query-string';
import { getLocalStorageValues } from 'constants/local-storage';
import { toggleAppDrawer } from '../../store/action/common-actions';
import { useDispatch } from 'react-redux';
import ViewAllTickets from './view-all-tickets/ViewAllTickets';
import DetailViewAllTickets from './detail-view-all-tickets/DetailViewAllTickets';
import Changelog from './changelog/Changelog';
import Macros from './macros/Macros';
import EditNewMacro from './new_macro/EditNewMacro';
import CreateTicketContainer from './create_ticket/CreateTicketContainer';
import NewMacroContainer from './new_macro/NewMacroContainer';

const MemberNavigator = ({ queryClient, isAppDrawerOpen }) => {
  const dispatch = useDispatch();
  let history = useHistory();
  let params = queryString.parse(history?.location?.search);
  let { userName } = getLocalStorageValues();
  if (params.bearer) {
    localStorage.setItem(
      'userName',
      JSON.stringify({
        userName: '',
        email: '',
        token: params.bearer,
      }),
    );
  }
  if (!userName?.userName && !params.bearer) {
    window.href = window.origin;
    return <Redirect from="*" to="/" />;
  }
  return (
    <Styles.MemberNavigatorSC>
      <AppDrawerContainer />
      <Styles.PageHeaderBodyContainer>
        <HeaderContainer queryClient={queryClient} />
        <Styles.PageContainer
          isAppDrawerOpen={isAppDrawerOpen}
          onClick={() => (isAppDrawerOpen ? dispatch(toggleAppDrawer()) : {})}
        >
          <Styles.PageContent isAppDrawerOpen={isAppDrawerOpen}>
            <Switch>
              <Route path={navLinks.home.link}>
                <Dashboard />
              </Route>
              <Route exact path={navLinks.admin_tickets_create.link}>
                <CreateTicketContainer />
              </Route>
              <Route exact path={navLinks.detail_view_all_tickets.link}>
                <DetailViewAllTickets />
              </Route>
              <Route path={navLinks.view_user_tikets.link}>
                <ViewAllTickets />
              </Route>
              <Route exact path={navLinks.changelog.link}>
                <Changelog />
              </Route>
              <Route exact path={navLinks.admin_kb_macros_create.link}>
                <NewMacroContainer />
              </Route>
              <Route exact path={navLinks.admin_kb_macros.link}>
                <Macros />
              </Route>
              <Route exact path={navLinks.admin_kb_macros_id.link}>
                <EditNewMacro />
              </Route>
              <Route path={'*'}>
                <NotFound />
              </Route>
            </Switch>
          </Styles.PageContent>
        </Styles.PageContainer>
      </Styles.PageHeaderBodyContainer>
    </Styles.MemberNavigatorSC>
  );
};

export default MemberNavigator;
